var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { staticClass: "order__box__range-label" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("checkout:stepone.slots.title")) + "\n\n    "
      ),
      _c("input", {
        staticClass: "input-uislider",
        attrs: { id: "input-units", name: "data[Order][units]", type: "text" },
        domProps: { value: _vm.selectedUnits },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "range", attrs: { id: "unit-slider" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }